import clientUUID from '@/client.js';
import { domain } from '@/modules/common.js';

export const find = (lang, slug) => fetch(`${domain}/${lang}/pagini/${slug}`, {
  method: 'get',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});
